import React from "react";

export default function TodosError() {
  return <div>TodosError</div>;
}
